const messages = {
  $public_onboarding: {
    included: "Included",
    free: "Included",
    free_text: "Free",
    referral_text: "referral",
    payment_page_values: {
      reviews_number: "{number_of_reviews} Trustpilot reviews",
      allow_sleek_to_stay_in_touch_text:
        "Allow Sleek to stay in touch regarding new products and updates. You can unsubscribe at anytime.",
      mandatory_declaration_text:
        "On behalf of all subscribers, I confirm I am forming the company for a lawful purpose.",
      mandatory_declaration_title: "Mandatory Declaration",
      mandatory_declaration_wanning_text:
        "Your confirmation is required to proceed with payment.",
      allow_sleek_to_stay_in_touch_title: "Notification Preferences",
    },
    copy: {
      satisfaction_guaranteed_subtext_uk:
        "We will refund the Sleek fees engaged within the first 28 days, should you be unhappy with our service.",
      satisfaction_guaranteed_subtext_with_sleek:
        "If you’re not happy with the service, we’ll refund you (only valid within 28 days of purchase).",
    },
    send_quote: {
      button: "Book a call",
      span: "Need consultation?",
    },
    buttons: {
      need_guidance: "Book a call",
    },
    checkout_values: {
      sub_header: "Save progress and pay later",
      sub_header_mobile: "Book a call",
      category: {
        business_account_text: "Business Account",
        business_account_sub_text:
          "Stay compliant with local regulations by sining up for one of these business accounts today.",
      },
    },
    footnote: {
      terms_and_privacy_text_uk: "",
    },
    form_member: {
      header_home_address: "{memberType}'s Home Address",
      header_service_address: "{memberType}'s Service Address",
      description_home_address:
        "Home address will not be shown on public records",
      description_service_address:
        "Service address will not be shown on public records",
    },
    additional_services_key: {
      enhanced_incorporation: "Enhanced Incorporation Services",
      protect_and_business: "Protect Your Privacy",
      stay_compliant: "Stay Compliant with UK Regulations",
      worry_free_business: "Worry-Free Business Management",
    },
    additional_services_key_description: {
      enhanced_incorporation:
        "Ensure accuracy, protect against fraud, and expedite your business registration.",
      protect_and_business:
        "Maintain confidentiality and keep personal details off the public record.",
      stay_compliant: "Meet mandatory legal requirements and avoid penalties.",
      worry_free_business:
        "Let us handle your ongoing compliance, filings, and administrative tasks.",
    },
  },
};

export default messages;
